import React from 'react';

import type { Routes } from '../../router';

import { useAccountCardsRequestStore } from '../../store/useAccountCardsRequestStore';
import { useAuthContext } from '../../context/AuthProvider';
import { useNavigate } from '../../router/hooks';
import { buildAccountBillingRoute } from './accountBillingRoute';

/**
 * Opens Account settings → Subscriptions → Cards once a notification asked
 * for it (a failed or suspended card charge, `billing_payment_problem`) —
 * the payer's own card list: `personal`, or the paying organization's.
 * Hosted in AppLayout, like the other notification targets.
 */
export const AccountCardsRequestHost = () => {
  const { clear, scope } = useAccountCardsRequestStore();
  const { currentUser } = useAuthContext();
  const navigate = useNavigate();
  const userId = currentUser?.id;

  React.useEffect(() => {
    if (!scope || !userId) return;
    clear();
    navigate(
      buildAccountBillingRoute({ scope, tab: 'cards', userId }) as Routes,
    );
  }, [clear, navigate, scope, userId]);

  return null;
};
